import { render, staticRenderFns } from "./company-memberships.vue?vue&type=template&id=61f5854a&"
import script from "./company-memberships.vue?vue&type=script&lang=js&"
export * from "./company-memberships.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports